import { gql } from '@/__generated__';

const GET_DEVICE_PROFILE_INFO = gql(`#graphql
  query DeviceProfileModal_GetDeviceProfileInfo($input: DeviceInput!) {
    device(input: $input) {
      id
      profile {
        id
        name
        type
        created
        project
        location {
          latitude
          longitude
        }
        organization {
          id
          name
        }
        irrigation {
          id
          name
        }
        odooTickets {
          id
          name
          description
        }
      }
      hardwareConfiguration {
        id
        images
      }
    }
  }
`);

export default GET_DEVICE_PROFILE_INFO;
